export default [
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/dashboard',
        name: 'referral-dashboard',
        component: () => import('./pages/ReferralPortal/Dashboard/ReferralPortalDashboard.vue'),
    }
]

